export type CalculateVenueEnv = {
  global: CalculateVenueGlobalEnv;
  structure: CalculateVenueStructureEnv;
  dates: CalculateVenueDatesEnv;
};

export type CalculateVenueGlobalEnv = {
  score: number; // 29,75 (structure + dates)
  maxScore: number; // 35 (structure + dates)
  scoreLetter: string; // A B C D E
};

export type CalculateVenueStructureEnv = {
  scoreLetter: string;
  score: number;
  maxScore: number;
  topics: {
    FOOD_BEVERAGES: {
      score: number;
      maxScore: number;
      sections: {
        CATERING: { score: number; maxScore: number };
        BEVERAGES: { score: number; maxScore: number };
        DISHES: { score: number; maxScore: number };
      };
    };
    RESOURCES_POLLUTION: {
      score: number;
      maxScore: number;
      sections: {
        INTENSITY?: { score: number; maxScore: number };
        WATER: { score: number; maxScore: number };
        ENERGY: { score: number; maxScore: number };
        WASTE_ECODESIGN: { score: number; maxScore: number };
        POLLUTION_LOCATION: { score: number; maxScore: number };
      };
    };
    COMMUNICATION: {
      score: number;
      maxScore: number;
      sections: {
        PHYSICAL_COMMUNICATION: { score: number; maxScore: number };
        DIGITAL_COMMUNICATION: { score: number; maxScore: number };
      };
    };
    PUBLIC_ENGAGEMENT: {
      score: number;
      maxScore: number;
      sections: {
        MOBILITY_STRATEGY: { score: number; maxScore: number };
        PUBLIC_INFORMATION: { score: number; maxScore: number };
      };
    };
  };
};

export type CalculateVenueDatesEnv = {
  score: number;
  maxScore: number;
  scoreLetter: string;
};

export const EMPTY_CALCULATE_VENUE_ENV: CalculateVenueEnv = {
  global: {
    score: 0,
    maxScore: 0,
    scoreLetter: '-',
  },
  structure: {
    scoreLetter: '-',
    score: 0,
    maxScore: 0,
    topics: {
      FOOD_BEVERAGES: {
        score: 0,
        maxScore: 0,
        sections: {
          CATERING: { score: 0, maxScore: 0 },
          BEVERAGES: { score: 0, maxScore: 0 },
          DISHES: { score: 0, maxScore: 0 },
        },
      },
      RESOURCES_POLLUTION: {
        score: 0,
        maxScore: 0,
        sections: {
          INTENSITY: { score: 0, maxScore: 0 },
          WATER: { score: 0, maxScore: 0 },
          ENERGY: { score: 0, maxScore: 0 },
          WASTE_ECODESIGN: { score: 0, maxScore: 0 },
          POLLUTION_LOCATION: { score: 0, maxScore: 0 },
        },
      },
      COMMUNICATION: {
        score: 0,
        maxScore: 0,
        sections: {
          PHYSICAL_COMMUNICATION: { score: 0, maxScore: 0 },
          DIGITAL_COMMUNICATION: { score: 0, maxScore: 0 },
        },
      },
      PUBLIC_ENGAGEMENT: {
        score: 0,
        maxScore: 0,
        sections: {
          MOBILITY_STRATEGY: { score: 0, maxScore: 0 },
          PUBLIC_INFORMATION: { score: 0, maxScore: 0 },
        },
      },
    },
  },
  dates: {
    score: 0,
    maxScore: 0,
    scoreLetter: '-',
  },
};
